/**
 * Packaging OS — Trust banner.
 *
 * Per trust-components-spec.md §1: pinned to top, never dismissable,
 * amber band, one canonical translation key.
 */

interface TrustBannerProps {
  message: string;
}

export function TrustBanner({ message }: TrustBannerProps): JSX.Element {
  return (
    <div role="status" aria-live="polite" className="po-trust-banner">
      {message}
    </div>
  );
}
